/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateAutopilotDto } from '../models/CreateAutopilotDto';
import type { UpdateAutopilotDto } from '../models/UpdateAutopilotDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AutopilotService {
    /**
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public static autopilotControllerCreateV1(
        requestBody: CreateAutopilotDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/autopilots',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public static autopilotControllerFindAllV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/autopilots',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public static autopilotControllerFindActiveV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/autopilots/active',
        });
    }
    /**
     * @param id
     * @returns any
     * @throws ApiError
     */
    public static autopilotControllerFindOneV1(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/autopilots/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public static autopilotControllerUpdateV1(
        id: string,
        requestBody: UpdateAutopilotDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/autopilots/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns any
     * @throws ApiError
     */
    public static autopilotControllerDeleteV1(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/autopilots/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @param scheduledAt
     * @returns any
     * @throws ApiError
     */
    public static autopilotControllerGenerateBatchV1(
        id: string,
        scheduledAt: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/autopilots/{id}/generate',
            path: {
                'id': id,
            },
            query: {
                'scheduledAt': scheduledAt,
            },
        });
    }
}
